import { render } from "./transfer_to_w_history.vue?vue&type=template&id=a9e6ba60&scoped=true"
import script from "./transfer_to_w_history.vue?vue&type=script&lang=js"
export * from "./transfer_to_w_history.vue?vue&type=script&lang=js"

import "./transfer_to_w_history.vue?vue&type=style&index=0&id=a9e6ba60&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e6ba60"]])

export default __exports__